<template>

  <div class="relative flex h-16 items-center justify-between">
    <router-link to="/">
      <img v-if="currentPage.name == 'Home'" src="@/assets/logo-title.svg" class="md:invisible md:h-0 md:w-0 pl-4 h-5 my-auto dark:hidden" alt="Logo and name">
      <img v-if="currentPage.name == 'Home'" src="@/assets/logo-title-dark.svg" class="md:invisible md:h-0 md:w-0 pl-4 h-5 my-auto hidden dark:block" alt="Logo and name">
      <img v-if="currentPage.name != 'Home'" src="@/assets/logo-title.svg" class="justify-end pl-4 h-5 my-auto dark:hidden" alt="Logo and name">
      <img v-if="currentPage.name != 'Home'" src="@/assets/logo-title-dark.svg" class="justify-end pl-4 h-5 my-auto hidden dark:block" alt="Logo and name">
    </router-link>

    <nav id="nav" class="flex justify-end items-center space-x-4 pr-4 py-3">
      <router-link to="/">Home</router-link>
      <router-link to="/about">About</router-link>
      <button @click="toggleDark" class="focus:outline-none w-5 h-5" :title="dark ? 'Switch to light mode' : 'Switch to dark mode'">
        <svg v-if="dark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="5"/>
          <line x1="12" y1="1" x2="12" y2="3"/>
          <line x1="12" y1="21" x2="12" y2="23"/>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
          <line x1="1" y1="12" x2="3" y2="12"/>
          <line x1="21" y1="12" x2="23" y2="12"/>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
        </svg>
      </button>
    </nav>
  </div>

  <router-view/>

</template>

<script>
import router from './router';

export default {
  data() {
    return {
      currentPage: router.currentRoute,
      dark: false,
    }
  },
  mounted() {
    this.dark = localStorage.getItem('darkMode') === 'true';
    this.applyDark();
  },
  methods: {
    toggleDark() {
      this.dark = !this.dark;
      localStorage.setItem('darkMode', this.dark);
      this.applyDark();
    },
    applyDark() {
      document.documentElement.classList.toggle('dark', this.dark);
    },
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2d4057;
  transition: background-color 0.2s, color 0.2s;
}

#nav a {
  color: #2d4057;
}

html.dark body {
  background-color: #1a202c;
}

html.dark #app {
  color: #e2e8f0;
}

html.dark #nav a {
  color: #e2e8f0;
}
</style>
